import type { ProjectKey } from '@repo/project-interface';
import sanitizeFilename from 'sanitize-filename';
import { makeProjectFile, type ProjectHeader } from '../util/project-file-util';

const PJT_FILE_EXTS = {
  js: '.jspjt',
  p5: '.p5pjt',
  py: '.pypjt',
  blox: '.blox',
};

/**
 * ProjectSerializer는 모든 프로젝트가 함께 사용한다.
 * addBlob()을 호출하여 프로젝트 데이터 파일들을 ZIP에 포함한 후
 * serialize()를 호출하면 된다.
 * const serializer = new ProjectSerializer();
 * serializer
 *     .addBlob(blob1, 'src', 'main.js')
 *     .addBlob(blob1, 'src', 'index.html');
 * serializer.serialize({
 *     breed:'js',
 *     projectKey: {accountId:0, projectId:'xxxx'},
 *     projectName:'hello',
 * });
 */
export async function serializeProject(
  options: {
    breed: keyof typeof PJT_FILE_EXTS;
    projectKey: ProjectKey | undefined;
    projectName: string;
  },
  loadZipFile: Blob | (() => Promise<Blob>),
): Promise<File> {
  const { breed, projectKey, projectName } = options;
  const header: ProjectHeader = {
    breed,
    project: projectKey,
    projectName,
  };
  const fileExtension = PJT_FILE_EXTS[breed];
  const fileName = sanitizeFilename(projectName) + fileExtension;
  const zipBlob = typeof loadZipFile === 'function' ? await loadZipFile() : loadZipFile;
  const projBlob = await makeProjectFile(zipBlob, header);
  return new File([projBlob], fileName, { type: 'application/octet-stream' });
}
